import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import useDesktop from "./hooks/useDesktop";
import usePrefersReducedMotion from "./hooks/usePrefersReducedMotion";
import useAnimationOverride from "./hooks/useAnimationOverride";
import useGlobalFetchLoading from "./hooks/useGlobalFetchLoading";
import { LoadingProvider } from "./context/LoadingContext";



import NameGuard from "./components/NameGuard";
// Importe für deine Komponenten
import PageWrapper from "./components/PageWrapper";
// KORREKTUR: Importiere CookieModal, da deine Datei so heißt
import CookieModal from "./components/CookieModal"; // <-- HIER IST DIE KORREKTUR


// Import ZenCursor Customizer 

import ZenCursor from "./kits/DesignKit/ZenCursor.jsx";
import "./kits/DesignKit/zenCursor.css";


import ProfessionEditor from "./components/ProfessionEditor.jsx";
import OrbitCustomizer from "./components/OrbitCustomizer.jsx";

// import math Code 

import Math from "./components/math.jsx";
import SectionD from "./components/SectionD.jsx";
import ZenPostStudioLandingPageHero from "./components/ZenPostStudioLandingPageHero.jsx";
import SectionZen from "./components/SectionZen.jsx";
import BlogHeroList from "./components/BlogHeroList.jsx";
import NotFound from "./components/404.jsx";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import GlobalLoadingOverlay from "./components/GlobalLoadingOverlay";
import { CourseProvider } from "./context/CourseContext";
import { NameProvider, NameContext } from "./context/NameContext";
import BitterButtonParentSimple from "./components/BitterButtonParentSimple";
import NameForm from "./components/NameForm";
import ScrollToTop from "./components/scrollTo.jsx";
import Kompass from "./components/Kompass";
import About from "./components/About";
import Courses from "./components/Courses";
import Course from "./components/Course";
import NewCourse from "./components/NewCourse";
import EditCourse from "./components/EditCourse";
import LoginPage from "./components/LoginAdmin";
import Register from "./components/register";
import Contact from "./components/Contact";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import AdminResetPassword from "./components/AdminResetPassword.jsx";
import ResetPassword from "./components/ResetPassword.jsx";
import CourseDetailsAndRegistration from "./components/CourseDetailsAndRegistration";
import PersonalizedMarketing from "./components/PersonaliseMarketing";
import ZenLab2 from "./components/ZenLab2";
import SocialPost from "./components/SocialPost";
import Succes from "./components/Succes";
import AdminDashboard from "./components/AdminDashboard.js";
import ForgotPassword from "./components/ForgotPassword.js";
import UserDashboard from "./components/UserDashboard.jsx";
import AdminCourseCockpit from "./components/AdminCourseCockpit.jsx";
import SeoHelmet from "./components/SeoHelmet.jsx";
import PatternKit from "./kits/DesignKit/PatternKit";
import ZenDevHeroList from "./components/ZenDevHeroList.jsx";
import { AuthProvider } from "./auth/AuthContext";

import LessonTabs from "./courses/LessonTabs.jsx";
import LogbookEntry from "./components/LogbookEntry.jsx";
import {PopularCourseProvider} from "./context/PopularCourseContext.js";
import Blog from "./components/Blog.jsx";
import Post from "./components/Post.jsx";
import BlogEditor from "./components/BlogEditor.jsx";
import ZenPost from "./components/ZenPost.jsx";
import CasePost from "./components/CasePost.jsx";
import LinkedinBlogEditor from "./components/LinkedinBlogEditor.jsx";
import SmartBlogEditor from "./components/SmartBlogEditor.jsx";
import SmartZenEditor from "./components/SmartZenEditor.jsx";
import Datenschutz from "./components/Datenschutz.jsx";
import Impressum from "./components/Impressum.jsx";
import SkillManager from "./components/SkillManager.jsx";
import ProjectManager from "./components/ProjectManager.jsx";
import BuildCustomCourse from "./components/BuildCustomCourse.jsx";
import UserCustomDashboard from "./components/UserCustomDashboard.jsx";
import CourseCockpitUser from "./components/CourseCockpitUser.jsx";
import BuilderPage from "./components/BuilderPage.jsx";
import AOS from 'aos';
import 'aos/dist/aos.css';

import SectionBlog from "./components/SectionBlog.jsx";
import ZenEditorLandingPage from "./components/ZenEditorLandingPage.jsx";
import ZenPostStudioLandingPage from "./components/ZenPostStudioLandingPage.jsx";
import { scrollHeaderIntoView } from "./components/utils/scrollToHeader";
import SearchResults from "./components/SearhResults";
import CourseHeroList from "./components/CourseHeroList";
import CourseNew from "./components/CourseNew";
import CourseCopy from "./components/CourseCopy";
import ProjectDetail from "./routes/ProjectDetail";
import { PaperDarkBG } from "./kits/index.js";
import Callback from "./components/Callback.jsx";
import SmartCaseEditor from "./components/SmartCaseEditor.jsx";

// Diese Komponente kapselt die Layout- und Navigationslogik
function AppContent() {
  const [isReady, setIsReady] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem("appPreloaderShown") === "1";
  }); // Für den globalen Preloader (nur einmal pro Session)
  useGlobalFetchLoading();
  const location = useLocation();
  const [navbarHeight, setNavbarHeight] = useState(0); // Zustand für die dynamische Navbar-Höhe
  const { isNameEntered = false } = useContext(NameContext); // NameContext, um isNameEntered zu bekommen

  // NEUER STATE FÜR COOKIE MODAL SICHTBARKEIT
  const [showCookieModal, setShowCookieModal] = useState(false); // <-- Hier 'showCookieModal' verwenden
  // NEUER STATE FÜR DEN INITIALEN COOKIE CONSENT ZUSTAND (wird geladen und dann an Modal übergeben)
  const [initialCookieConsent, setInitialCookieConsent] = useState(null);
  const cookieModalRef = useRef(null); // Ref für das Cookie-Modal


  // USEEFFECT für Blog zum scrollen ohne Namem 

    // 🔐 Definiere Ausnahmen für isNameEntered
  const nameBypassRoutes = [
    "/blog",
    "/post/",
    "/zen/",
    "/case/",
    "/datenschutz",
    "/impressum",
    "/zenlab2",
    "/zenlab",
    "/contact"
  ];
  const isBypassed = nameBypassRoutes.some((prefix) =>
    location.pathname.startsWith(prefix)
  );


  // 3D Modell Hero vorladen 

  useEffect(() => {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "fetch";
  link.href = "https://www.denisbitter.de/uploads/models/mac_1982.glb";
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}, []);

  // AOS initialisieren
  useEffect(() => {
    AOS.init({ duration: 600, once: true, easing: 'ease-out' });
  }, []);

  // Browser Scroll-Restore deaktivieren (verhindert Sprünge)
  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
      return () => {
        window.history.scrollRestoration = "auto";
      };
    }
  }, []);






/* // neuer Preloader ohne Time 

useEffect(() => {
  const initApp = async () => {
    // Hier: echtes Laden/Authentifizieren, z.B. Cookies, API, etc.
    // await irgendwasEchtes();

    // Cookie-Zustimmung prüfen
    const stored = localStorage.getItem("cookieConsentV2");
    if (!stored) {
      setShowCookieModal(true);
      setInitialCookieConsent({
        essential: true,
        statistics: false,
        media: false,
      });
    } else {
      setInitialCookieConsent(JSON.parse(stored));
    }
    setIsReady(true); // Sobald alles geladen/gecheckt
  };
  initApp();
}, []);
 */


// alter TimeOut Preoloader 
  // Globaler Preloader für die App-Initialisierung UND Cookie-Check
  useEffect(() => {
    const initApp = async () => {
      const alreadyShown =
        typeof window !== "undefined" && sessionStorage.getItem("appPreloaderShown") === "1";

      if (!alreadyShown) {
        await new Promise(resolve => setTimeout(resolve, 1500)); // Globale Verzögerung
        if (typeof window !== "undefined") {
          sessionStorage.setItem("appPreloaderShown", "1");
        }
      }
      setIsReady(true);

      // Überprüfe Cookie-Zustimmung beim App-Start
      const stored = localStorage.getItem("cookieConsentV2");
      if (!stored) {
        // Wenn keine Zustimmung gefunden, Modal anzeigen
        setShowCookieModal(true); // <-- Hier 'setShowCookieModal' verwenden
        // Initialisiere den Consent-State mit Standardwerten, da noch nichts gespeichert ist
        setInitialCookieConsent({
          essential: true,
          statistics: false,
          media: false,
        });
      } else {
        // Wenn Zustimmung gefunden, lade sie und speichere sie, aber Modal nicht anzeigen
        setInitialCookieConsent(JSON.parse(stored));
      }
    };
    initApp();
  }, []); // Leeres Array, damit dies  

  // Callback-Funktion, um die Navbar-Höhe von der Navbar-Komponente zu empfangen
  const updateNavbarHeight = useCallback((newHeight) => {
    setNavbarHeight(newHeight);
  }, []);

  const isDesktop = useDesktop();
  const prefersReduced = usePrefersReducedMotion();
  const animOverride = useAnimationOverride();
  const shouldAnimate = animOverride ?? (isDesktop && !prefersReduced);
  const [homeHeroDone, setHomeHeroDone] = useState(!shouldAnimate);
  const [homeAccordionOpen, setHomeAccordionOpen] = useState(null);
  const zenListRef = useRef(null);
  const serviceHeaderRef = useRef(null);
  const techHeaderRef = useRef(null);
  const zenHeaderRef = useRef(null);
  const blogHeaderRef = useRef(null);
  const courseHeaderRef = useRef(null);
  const blogListRef = useRef(null);
  const courseListRef = useRef(null);

  useEffect(() => {
    if (location.pathname === "/" && shouldAnimate) setHomeHeroDone(false);
  }, [location.pathname, shouldAnimate]);

  useEffect(() => {
    if (!shouldAnimate) setHomeHeroDone(true);
  }, [shouldAnimate]);

  useEffect(() => {
    if (location.pathname !== "/") {
      setHomeAccordionOpen(null);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/" || !homeAccordionOpen) return;
    const sectionRefs = {
      services: serviceHeaderRef,
      tech: techHeaderRef,
      zen: zenHeaderRef,
      blog: blogHeaderRef,
      courses: courseHeaderRef,
    };
    const target = sectionRefs[homeAccordionOpen]?.current;
    if (!target) return;

    // Wait for the 700ms CSS close-transition of the previous section to finish
    const timer = setTimeout(() => {
      scrollHeaderIntoView(target, "smooth", 8);
    }, 720);
    return () => clearTimeout(timer);
  }, [homeAccordionOpen, location.pathname]);

  useEffect(() => {
    document.documentElement.style.setProperty("--navbar-height", `${navbarHeight}px`);
    return () => {
      document.documentElement.style.removeProperty("--navbar-height");
    };
  }, [navbarHeight]);

  // Funktion zum Schließen des Cookie-Modals
  const handleCloseCookieModal = useCallback(() => { // <-- Hier 'handleCloseCookieModal'
    setShowCookieModal(false); // <-- Hier 'setShowCookieModal' verwenden
  }, []);

  const toggleHomeAccordion = useCallback((section) => {
    setHomeAccordionOpen((current) => (current === section ? null : section));
  }, []);




  // Der globale Preloader für die gesamte App
  if (!isReady) {
    return <Preloader isReady={isReady} />;
  }

  return (
    <div className={`App ${!isNameEntered && !isBypassed ? "overflow-hidden h-screen" : ""}`}>
{isNameEntered && <Navbar updateNavbarHeight={updateNavbarHeight} />}


       {!isNameEntered && !isBypassed && <NameForm />}

      <div
        className="main-content relative"
        style={{ paddingTop: `${navbarHeight}px`, "--navbar-height": `${navbarHeight}px` }}
      >
        <GlobalLoadingOverlay />

  <ZenCursor />
        <ScrollToTop />
        {/* HIER WIRD DAS COOKIE-MODAL BEDINGT GERENDERT */}
        {showCookieModal && ( // <-- Hier 'showCookieModal' verwenden
          <CookieModal // <-- HIER CookieModal verwenden
            ref={cookieModalRef} // Ref für Klick außerhalb
            initialConsent={initialCookieConsent} // Initialen Zustand übergeben
            onClose={handleCloseCookieModal} // <-- Hier 'handleCloseCookieModal' verwenden
          />
        )}
        {/* Die alte <CookieModal /> Zeile sollte hier entfernt werden,
            da wir jetzt die neue, gesteuerte CookieModal Komponente verwenden */}
        {/* <CookieModal />  <-- DIESE ZEILE MUSS ENTFERNT WERDEN */}

       {isNameEntered && <BitterButtonParentSimple />}
       <AnimatePresence mode="wait">
  <Routes location={location} key={location.pathname}>
    {/* Hauptseite bleibt ohne Guard */}
    <Route path="/" element={
      <>
<SeoHelmet
  title="Denis Bitter – Software Architect & Full-Stack Engineering Instructor"
  description="FullStack Entwickler, Dozent für digitale Bildung. Ich entwickle klare Systeme für Lernen, Web & App – durchdacht, echt, skalierbar. EdTech. Medien. Lösungen mit Haltung."
  url="https://www.denisbitter.de/"
  image="https://www.denisbitter.de/images/hero-og.jpg"
/>

        <PageWrapper>
          <PersonalizedMarketing
            id="personalized-section"
            onHeroDone={() => setHomeHeroDone(true)}
            homeAccordionOpen={homeAccordionOpen}
            onAccordionToggle={toggleHomeAccordion}
            serviceHeaderRef={serviceHeaderRef}
            techHeaderRef={techHeaderRef}
          />
          <main
            className={`${homeHeroDone ? "opacity-100" : "opacity-0 pointer-events-none"} transition-opacity duration-900 ease-out`}
            aria-hidden={!homeHeroDone}
          >
            <div className="zenlist-area">
              <div className="mt-0">
                <SectionZen
                  onToggle={() => toggleHomeAccordion("zen")}
                  isOpen={homeAccordionOpen === "zen"}
                  headerRef={zenHeaderRef}
                  autoScrollOnOpen={false}
                />
              </div>
              <div
                ref={zenListRef}
                className={`mt-0 overflow-hidden transform-gpu transition-[max-height,opacity,transform] duration-700 ease-out will-change-[max-height,opacity,transform] ${
                  homeAccordionOpen === "zen"
                    ? "max-h-[2000px] opacity-100 translate-y-0"
                    : "max-h-0 opacity-0 -translate-y-2 pointer-events-none"
                }`}
                aria-hidden={homeAccordionOpen !== "zen"}
              >
                <PaperDarkBG>
                  <ZenDevHeroList />
                </PaperDarkBG>
              </div>
            </div>
            <SectionBlog
              onToggle={() => toggleHomeAccordion("blog")}
              isOpen={homeAccordionOpen === "blog"}
              headerRef={blogHeaderRef}
              autoScrollOnOpen={false}
            />
            
            <div
              ref={blogListRef}
              className={`overflow-hidden transform-gpu transition-[max-height,opacity,transform] duration-700 ease-out will-change-[max-height,opacity,transform] ${
                homeAccordionOpen === "blog"
                  ? "max-h-[2400px] opacity-100 translate-y-0"
                  : "max-h-0 opacity-0 -translate-y-2 pointer-events-none"
              }`}
              aria-hidden={homeAccordionOpen !== "blog"}
            >
              <PaperDarkBG>
            <BlogHeroList />
            </PaperDarkBG>
            </div>

            <SectionD
              onToggle={() => toggleHomeAccordion("courses")}
              isOpen={homeAccordionOpen === "courses"}
              headerRef={courseHeaderRef}
              autoScrollOnOpen={false}
            />
            <div
              ref={courseListRef}
              className={`overflow-hidden transform-gpu transition-[max-height,opacity,transform] duration-700 ease-out will-change-[max-height,opacity,transform] ${
                homeAccordionOpen === "courses"
                  ? "max-h-[2400px] opacity-100 translate-y-0"
                  : "max-h-0 opacity-0 -translate-y-2 pointer-events-none"
              }`}
              aria-hidden={homeAccordionOpen !== "courses"}
            >
              <PaperDarkBG>
                <CourseHeroList />
              </PaperDarkBG>
            </div>
                   
   <ZenPostStudioLandingPageHero />
          </main>
        </PageWrapper>
      </>
    } />

    {/* ALLE WEITEREN Routen um NameGuard wickeln, ausgenommen explizite Ausnahmen */}
    <Route element={<NameGuard />}>  {/* Alles darunter wird geschützt */}
     
    </Route>

    {/* AUSSNAHMEN vom Guard: öffentlich */}
    <Route path="/zeneditor" element={<PageWrapper><ZenEditorLandingPage /></PageWrapper>} />
    <Route path="/zenpost-studio" element={<PageWrapper><ZenPostStudioLandingPage /></PageWrapper>} />
    <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />
    <Route path="/loginadmin" element={<PageWrapper><LoginPage /></PageWrapper>} />
    <Route path="/blog" element={<PageWrapper><Blog /></PageWrapper>} />
    <Route path="/post/:slug" element={<PageWrapper><Post /></PageWrapper>} />
    <Route path="/zen/:slug" element={<PageWrapper><ZenPost /></PageWrapper>} />
      <Route path="/casestudy/:slug" element={<PageWrapper><CasePost /></PageWrapper>} />
    <Route path="/datenschutz" element={<PageWrapper><Datenschutz /></PageWrapper>} />
    <Route path="/impressum" element={<PageWrapper><Impressum /></PageWrapper>} />
    <Route path="/zenlab" element={<Navigate to="/zenlab2" replace />} />
    <Route path="/zenlab2" element={<PageWrapper><ZenLab2 /></PageWrapper>} />
    <Route path="/lernstudio" element={<Navigate to="/zenlab2" replace />} />
       <Route path="/admindashboard" element={<PageWrapper><AdminDashboard /></PageWrapper>} />
          <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
      <Route path="/course-edit/edit:slug" element={<PageWrapper><EditCourse /></PageWrapper>} />
      <Route path="/course-edit/new" element={<EditCourse />} />
      <Route path="/course/new" element={<EditCourse />} />
<Route path="/course/edit/:slug" element={<EditCourse />} />




    <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
     <Route path="/logbuch" element={<PageWrapper><LogbookEntry /></PageWrapper>} />
     <Route path="/orbit" element={<PageWrapper><OrbitCustomizer /></PageWrapper>} />

      <Route path="/math" element={<PageWrapper><Math /></PageWrapper>} />

      <Route path="/userdashboard" element={<PageWrapper><UserDashboard /></PageWrapper>} />
      <Route path="/courses" element={<PageWrapper><Courses /></PageWrapper>} />
      <Route path="/course/:slug" element={<PageWrapper><Course /></PageWrapper>} />
      <Route path="/new-course" element={<PageWrapper><NewCourse /></PageWrapper>} />


    <Route path="/callback" element={<PageWrapper><Callback /></PageWrapper>} />

      <Route path="/register" element={<PageWrapper><Register /></PageWrapper>} />
      <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} /> 
      <Route path="/anmeldung/:slug" element={<PageWrapper><CourseDetailsAndRegistration /></PageWrapper>} />
      <Route path="/dashboard" element={<PageWrapper><Dashboard /></PageWrapper>} />
      <Route path="/reset-password" element={<PageWrapper><ResetPassword /></PageWrapper>} />
      <Route path="/adminresetpassword" element={<PageWrapper><AdminResetPassword /></PageWrapper>} />
      <Route path="/search" element={<PageWrapper><SearchResults /></PageWrapper>} />
      <Route path="/socialpost" element={<PageWrapper><SocialPost /></PageWrapper>} />
      <Route path="/success" element={<PageWrapper><Succes /></PageWrapper>} />
      <Route path="/kompass" element={<PageWrapper><Kompass /></PageWrapper>} />
      <Route path="/patternkit" element={<PageWrapper><PatternKit /></PageWrapper>} />
      <Route path="/lesson-tabs" element={<PageWrapper><LessonTabs /></PageWrapper>} />
      <Route path="/coursecockpit/:courseId" element={<PageWrapper><CourseCockpitUser /></PageWrapper>} />
      <Route path="/blogeditor" element={<PageWrapper><BlogEditor /></PageWrapper>} />
      <Route path="/linkedinblogeditor" element={<PageWrapper><LinkedinBlogEditor /></PageWrapper>} />
      <Route path="/buildpage" element={<PageWrapper><BuilderPage /></PageWrapper>} />
      <Route path="/smarteditor" element={<PageWrapper><SmartBlogEditor /></PageWrapper>} />
      <Route path="/smartcaseeditor" element={<PageWrapper><SmartCaseEditor /></PageWrapper>} />
      <Route path="/professioneditor" element={<PageWrapper><ProfessionEditor /></PageWrapper>} />
      <Route path="/smartzeneditor" element={<PageWrapper><SmartZenEditor /></PageWrapper>} />
      <Route path="/skillmanager" element={<PageWrapper><SkillManager /></PageWrapper>} />
      <Route path="/prmanager" element={<PageWrapper><ProjectManager /></PageWrapper>} />
      <Route path="/bausteinkurs" element={<PageWrapper><BuildCustomCourse /></PageWrapper>} />
      <Route path="/dashboard-custom" element={<PageWrapper><UserCustomDashboard /></PageWrapper>} />
      <Route path="/coursematerial" element={<PageWrapper><AdminCourseCockpit /></PageWrapper>} />
      <Route path="/forgot-password" element={<PageWrapper><ForgotPassword /></PageWrapper>} />
      <Route path="/project/:slug" element={<PageWrapper><ProjectDetail /></PageWrapper>} />
      <Route path="/course-new" element={<PageWrapper><CourseNew /></PageWrapper>} />
      <Route path="/course-copy/:id" element={<PageWrapper><CourseCopy /></PageWrapper>} />
  </Routes>
</AnimatePresence>

      </div>
      {/* Footer erhält den Callback, um das Cookie-Modal zu öffnen */}
      <Footer onShowCookieSettings={() => setShowCookieModal(true)} /> {/* <-- Hier 'setShowCookieModal' */}
    </div>
  );
}

// Dies ist deine MainApp, die die Provider und den BrowserRouter kapselt.
const MainApp = () => (
  <AuthProvider>
    <CourseProvider>
      <PopularCourseProvider>
        <BrowserRouter>
          <LoadingProvider>
            <NameProvider> {/* NameProvider umschließt die gesamte AppContent */}
              <AppContent />
            </NameProvider>
          </LoadingProvider>
        </BrowserRouter>
      </PopularCourseProvider>
    </CourseProvider>
  </AuthProvider>
);

export default MainApp;
